<template>
  <div :class="mobile ? 'banner-carousel mobile' : 'banner-carousel'">
    <v-carousel
      hide-delimiters
      :show-arrows="false"
      v-model="bannerId"
      :cycle="true"
      height="100%"
    >
      <v-carousel-item
        v-for="(banner,i) in carousel"
        :key="i"
      >
        <div
          :class="mobile ? 'custom-banner mobile' : 'custom-banner'"
          :style="{backgroundImage:'url('+banner.image_data+')'}"
          v-if="banner.type === 'image'"
        ></div>
        <div
          :class="mobile ? 'banner mobile' : 'banner'"
          v-if="banner.type === 'item'"
          @click.stop="openItem(banner.product)"
        >
          <div
            class="image"
            v-if="banner.picture_url"
            :style="{backgroundImage:'url(' + banner.picture_url+')'}"
          ></div>
          <div
            class="image"
            style="box-sizing: border-box; padding: 2px;"
            v-if="!banner.picture_url"
            v-html="noImage"
          ></div>
          <div class="main">
            <div class="name">{{ banner.name }}</div>
            <div class="size" v-if="!banner.is_modifier">{{ banner.size }}</div>
            <div class="modifier" v-if="banner.is_modifier">Starting at</div>
            <div class="price">
              <span
                class="value main-text"
                :style="{color}"
              >${{ banner.price }}</span> /each
            </div>
          </div>
          <div class="ribbon" v-if="banner.discount">DEAL</div>
          <div class="ribbon green" v-if="!banner.discount && banner.new_product">NEW</div>
          <div class="information" v-if="banner.discount">
            {{ banner.discount }}
          </div>
        </div>
        <div
          v-if="banner.type === 'department'"
          :class="mobile ? 'banner mobile' : 'banner'"
          :style="{backgroundColor: color}"
          @click.stop="$router.push(`department/${banner.id}`)"
        >
          <div class="background">
            <div
              v-if="banner.picture_url"
              class="image department"
              :style="{backgroundImage:'url(' + banner.picture_url+')'}"
            ></div>
            <div
              class="image"
              style="box-sizing: border-box; padding: 2px;"
              v-if="!banner.picture_url"
              v-html="noImage"
            ></div>
            <div class="main">
              <div class="name department">{{ banner.name }}</div>
              <div class="subs">
                <div
                  class="sub main-text"
                  :style="{color}"
                  v-for="(sub,i) in banner.sub_departments"
                  :key="i"
                >{{ sub }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="banner.type === 'promotion'"
          :class="mobile ? 'banner mobile' : 'banner'"
          @click.stop="$router.push('deals')"
        >
          <div
            v-if="banner.picture_url"
            class="image"
            :style="{backgroundImage:'url(' + banner.picture_url+')'}"
          ></div>
          <div
            class="image"
            style="box-sizing: border-box; padding: 2px;"
            v-if="!banner.picture_url"
            v-html="noImage"
          ></div>
          <div class="main">
            <div class="name promotion">{{ banner.name }}</div>
            <div
              class="main-text"
              :style="{color}"
            >
              {{ banner.discount }}!
            </div>
          </div>
          <div class="ribbon" :class="{large: !mobile}">DEAL</div>
        </div>
        <div
          v-if="banner.type === 'points'"
          :class="mobile ? 'banner mobile' : 'banner'"
          @click.stop="openRewards"
        >
          <div class="image">
            <svg class="circle">
              <image :href="banner.picture_url ? banner.picture_url : ''"></image>
              <circle></circle>
            </svg>
          </div>
          <div class="main">
            <div class="name with-crown">{{ banner.name }}</div>
            <div
              class="main-text"
              :style="{color}"
            >
              {{ banner.points }} Points
            </div>
          </div>
          <div
            class="crown"
            v-html="crown"
          ></div>
        </div>
        <div
          v-if="banner.type === 'club'"
          :class="mobile ? 'banner mobile' : 'banner'"
          @click.stop="openRewards"
        >
          <div class="image">
            <svg class="circle">
              <image :href="banner.picture_url ? banner.picture_url : ''"></image>
              <circle
                :style="lines(banner.need_to_buy)"
              ></circle>
            </svg>
          </div>
          <div class="main">
            <div class="name with-crown">{{ banner.name }}</div>
            <div
              class="main-text"
              :style="{color}"
            >
              Buy {{ banner.need_to_buy }}, Get 1 FREE!
            </div>
          </div>
          <div
            class="crown"
            v-html="crown"
          ></div>
        </div>
      </v-carousel-item>
    </v-carousel>
    <div :class="mobile ? 'dots mobile' : 'dots'">
      <div
        class="circle"
        v-for="(banner,i) in carousel"
        :key="i"
        :class="{active: bannerId === i}"
        @click="bannerId = i"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { getProductDetailViewFromProductState } from "@/util.js";

export default {
  name: "BannerCarousel",
  beforeMount() {
    this.init(null, null, { root: true });
  },
  data: () => ({
    bannerId: 0,
  }),
  props: {
    mobile: Boolean,
  },
  computed: {
    ...mapState({
      carousel: (state) => state.bannerCarousel.carousel,
      color: (state) => state.store.info.store_info.customization?.website.style.primary_color,
    }),
    crownSize() {
      return this.mobile ? "74" : "155";
    },
    noImage() {
      return `
      <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="200" height="200" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M124.643 71.1902L115.536 65.2463C114.745 64.73 113.82 64.4594 112.876 64.4685C111.932 64.4776 111.011 64.766 110.231 65.2974L101.251 71.4203C100.47 71.95 99.5502 72.2375 98.6065 72.2466C97.6628 72.2557 96.7375 71.986 95.9464 71.4714L86.8452 65.5275C86.0547 65.0106 85.1285 64.7401 84.1841 64.7503C83.2396 64.7606 82.3195 65.0511 81.5404 65.585L72.5031 71.7334C71.7351 72.256 70.8312 72.5429 69.9024 72.5588C68.9736 72.5747 68.0604 72.3189 67.275 71.8229L57.899 65.9237C57.6074 65.7399 57.2717 65.638 56.9272 65.6289C56.5826 65.6197 56.242 65.7036 55.9411 65.8717C55.6402 66.0398 55.3902 66.286 55.2173 66.5842C55.0445 66.8824 54.9553 67.2217 54.959 67.5663L55.6173 162.017L142.251 161.18L141.6 66.7994C141.596 66.4539 141.498 66.1159 141.318 65.8214C141.137 65.5269 140.88 65.2869 140.574 65.1269C140.267 64.9669 139.923 64.8929 139.579 64.9128C139.234 64.9327 138.901 65.0457 138.615 65.2399L129.942 71.1327C129.163 71.6666 128.243 71.9571 127.298 71.9673C126.354 71.9776 125.427 71.7071 124.637 71.1902H124.643Z" stroke="#888" stroke-width="8"/>
      <path d="M91.645 47.6313L113.139 39.6742L124.637 64.8559M76.5423 129.005H120.668H76.5423ZM54.9589 71.3559C54.9589 65.348 63.9003 47.9637 69.9017 47.9637C71.3296 47.962 72.7439 48.2418 74.0636 48.7871C75.3833 49.3324 76.5826 50.1324 77.5929 51.1415C78.6031 52.1506 79.4046 53.349 79.9514 54.668C80.4983 55.9871 80.7797 57.401 80.7797 58.8289L54.9589 71.3559Z" stroke="${this.color}" stroke-width="8" stroke-linecap="round"/>
      <path d="M122.118 55.4291L131.487 48.7693L138.045 65.016M82.6449 58.5097L80.4719 51.9906L113.138 39.6745L82.6449 58.5097Z" stroke="${this.color}" stroke-width="6.3913" stroke-linecap="round"/>
      </svg>
      `;
    },
    crown() {
      return `
      <svg width="${this.crownSize}" height="${this.crownSize}" viewBox="0 0 155 155" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M75.4657 3.27866V26.5999C75.4657 27.5935 76.3911 28.3966 77.536 28.3966C78.6809 28.3966 79.6064 27.5935 79.6064 26.5999V3.27866C79.6064 2.28508 78.6809 1.48196 77.536 1.48196C76.3911 1.48196 75.4657 2.28508 75.4657 3.27866Z" fill="${this.color}"/>
      <path d="M79.6064 127.5C79.6064 126.506 78.6809 125.703 77.536 125.703C76.3911 125.703 75.4657 126.506 75.4657 127.5V150.821C75.4657 151.815 76.3911 152.618 77.536 152.618C78.6809 152.618 79.6064 151.815 79.6064 150.821V127.5Z" fill="${this.color}"/>
      <path d="M128.204 22.7286L111.205 39.7278C110.481 40.4519 110.481 41.6223 111.205 42.3464C111.566 42.7076 112.04 42.8891 112.514 42.8891C112.988 42.8891 113.462 42.7076 113.824 42.3464L130.822 25.3473C131.546 24.6232 131.546 23.4527 130.822 22.7286C130.098 22.0045 128.928 22.0045 128.204 22.7286Z" fill="${this.color}"/>
      <path d="M41.2489 111.753L24.2501 128.753C23.526 129.477 23.526 130.648 24.2501 131.372C24.6112 131.733 25.0853 131.914 25.5594 131.914C26.0335 131.914 26.5076 131.733 26.8687 131.372L43.8675 114.372C44.5916 113.648 44.5916 112.477 43.8675 111.753C43.1434 111.029 41.973 111.031 41.2489 111.753Z" fill="${this.color}"/>
      <path d="M151.093 77.0499H125.082C123.974 77.0499 123.078 78.1681 123.078 79.5515C123.078 80.9349 123.974 82.0531 125.082 82.0531H151.093C152.201 82.0531 153.097 80.9349 153.097 79.5515C153.097 78.1681 152.201 77.0499 151.093 77.0499Z" fill="${this.color}"/>
      <path d="M4.67325 82.0531H26.349C27.2725 82.0531 28.0189 80.9349 28.0189 79.5515C28.0189 78.1681 27.2725 77.0499 26.349 77.0499H4.67325C3.74977 77.0499 3.00331 78.1681 3.00331 79.5515C3.00331 80.9349 3.74977 82.0531 4.67325 82.0531Z" fill="${this.color}"/>
      <path d="M130.822 128.753L113.824 111.754C113.099 111.03 111.929 111.03 111.205 111.754C110.481 112.478 110.481 113.648 111.205 114.373L128.204 131.372C128.565 131.733 129.039 131.914 129.513 131.914C129.987 131.914 130.461 131.733 130.822 131.372C131.546 130.649 131.546 129.477 130.822 128.753Z" fill="${this.color}"/>
      <path d="M42.5582 42.8891C43.0323 42.8891 43.5064 42.7076 43.8675 42.3464C44.5916 41.6223 44.5916 40.4519 43.8675 39.7278L26.8687 22.7286C26.1446 22.0045 24.9742 22.0045 24.2501 22.7286C23.526 23.4527 23.526 24.6232 24.2501 25.3473L41.2489 42.3464C41.61 42.7076 42.0841 42.8891 42.5582 42.8891Z" fill="${this.color}"/>
      <path d="M139.506 50.2942C139.117 49.3076 138.039 48.8394 137.095 49.2476L122.153 55.73C121.212 56.1382 120.765 57.2698 121.154 58.2584C121.448 59.0031 122.134 59.4519 122.859 59.4519C123.095 59.4519 123.333 59.4055 123.566 59.3049L138.508 52.8225C139.449 52.4124 139.896 51.2807 139.506 50.2942Z" fill="${this.color}"/>
      <path d="M15.5664 103.806C15.8598 104.551 16.5462 105 17.2714 105C17.5075 105 17.7456 104.953 17.9781 104.853L32.9201 98.3698C33.8611 97.9616 34.3077 96.8298 33.9183 95.8412C33.529 94.8546 32.4533 94.3883 31.5067 94.7946L16.5647 101.278C15.6236 101.688 15.1771 102.819 15.5664 103.806Z" fill="${this.color}"/>
      <path d="M104.303 137.644L97.821 122.701C97.4128 121.76 96.2851 121.315 95.2927 121.702C94.3062 122.092 93.8381 123.171 94.2462 124.114L100.728 139.057C101.036 139.768 101.755 140.196 102.516 140.196C102.763 140.196 103.013 140.151 103.257 140.056C104.243 139.666 104.711 138.587 104.303 137.644Z" fill="${this.color}"/>
      <path d="M51.8159 14.0439C50.8294 14.4333 50.3613 15.5128 50.7694 16.4557L57.2515 31.3987C57.5591 32.1091 58.2787 32.5372 59.0389 32.5372C59.2865 32.5372 59.536 32.493 59.7798 32.397C60.7663 32.0076 61.2344 30.9282 60.8263 29.9852L54.3442 15.0422C53.9341 14.1011 52.8083 13.6564 51.8159 14.0439Z" fill="${this.color}"/>
      <path d="M95.2927 32.397C95.5365 32.493 95.786 32.5372 96.0336 32.5372C96.7938 32.5372 97.5134 32.1091 97.821 31.3987L104.303 16.4557C104.711 15.5128 104.243 14.4333 103.257 14.0439C102.264 13.6564 101.138 14.1011 100.728 15.0422L94.2462 29.9852C93.8381 30.9282 94.3062 32.0076 95.2927 32.397Z" fill="${this.color}"/>
      <path d="M139.506 103.806C139.896 102.817 139.449 101.686 138.508 101.278L123.566 94.7946C122.621 94.3883 121.544 94.8546 121.154 95.8412C120.765 96.8298 121.212 97.9616 122.153 98.3698L137.095 104.853C137.327 104.953 137.565 105 137.801 105C138.526 105 139.213 104.551 139.506 103.806Z" fill="${this.color}"/>
      <path d="M15.5664 50.2942C15.1771 51.2827 15.6236 52.4143 16.5647 52.8225L31.5067 59.3049C31.7392 59.4055 31.9772 59.4519 32.2134 59.4519C32.9385 59.4519 33.6249 59.0031 33.9183 58.2584C34.3077 57.2698 33.8611 56.1382 32.9201 55.73L17.9781 49.2476C17.0296 48.8394 15.9558 49.3076 15.5664 50.2942Z" fill="${this.color}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M74.4305 3.27866C74.4305 1.58045 75.9621 0.446777 77.536 0.446777C79.11 0.446777 80.6416 1.58045 80.6416 3.27866V26.5999C80.6416 28.2981 79.11 29.4318 77.536 29.4318C75.9621 29.4318 74.4305 28.2981 74.4305 26.5999V3.27866ZM77.536 2.51713C76.8202 2.51713 76.5008 2.98971 76.5008 3.27866V26.5999C76.5008 26.8888 76.8202 27.3614 77.536 27.3614C78.2519 27.3614 78.5712 26.8888 78.5712 26.5999V3.27866C78.5712 2.98971 78.2519 2.51713 77.536 2.51713ZM51.4394 13.0797C52.918 12.5023 54.6475 13.147 55.2932 14.6287L61.776 29.5733C62.4291 31.0822 61.6604 32.7677 60.1598 33.3599C59.791 33.5051 59.4116 33.5724 59.0389 33.5724C57.9041 33.5724 56.7881 32.933 56.3019 31.8107L49.8197 16.8677C49.1666 15.3588 49.9388 13.6719 51.4394 13.0797ZM52.194 15.0076C51.7231 15.1946 51.5565 15.668 51.7194 16.0445L58.2012 30.9867C58.3303 31.2848 58.6535 31.5021 59.0389 31.5021C59.1614 31.5021 59.2819 31.4805 59.4006 31.4338C59.8724 31.2471 60.0394 30.7732 59.8763 30.3964L53.3952 15.4558C53.2203 15.0564 52.6991 14.8113 52.194 15.0076ZM99.7793 14.6287C100.425 13.147 102.155 12.5023 103.633 13.0797C105.134 13.6719 105.906 15.358 105.253 16.8669L98.7709 31.81C98.2848 32.9328 97.1686 33.5724 96.0336 33.5724C95.6609 33.5724 95.2823 33.5054 94.9135 33.3602C93.4129 32.768 92.6431 31.0829 93.2962 29.574L99.7793 14.6287ZM101.677 15.4558L95.1962 30.3964C95.0331 30.7732 95.2001 31.2471 95.6719 31.4338C95.7906 31.4805 95.9111 31.5021 96.0336 31.5021C96.419 31.5021 96.742 31.2855 96.871 30.9874L103.353 16.0445C103.516 15.668 103.35 15.1946 102.879 15.0076C102.373 14.811 101.852 15.0556 101.677 15.4558ZM23.5181 21.9966C24.6465 20.8682 26.4723 20.8682 27.6007 21.9966L44.5995 38.9958C45.7278 40.1242 45.7278 41.95 44.5995 43.0784C44.0369 43.641 43.2963 43.9242 42.5582 43.9242C41.8201 43.9242 41.0795 43.641 40.5169 43.0784L23.5181 26.0792C22.3898 24.9509 22.3898 23.125 23.5181 21.9966ZM26.1367 23.4606C25.8169 23.1407 25.3019 23.1407 24.9821 23.4606C24.6622 23.7804 24.6622 24.2954 24.9821 24.6153L41.9809 41.6145C42.1405 41.7741 42.3481 41.8539 42.5582 41.8539C42.7683 41.8539 42.9759 41.7741 43.1355 41.6145C43.4554 41.2946 43.4554 40.7796 43.1355 40.4597L26.1367 23.4606ZM127.472 21.9966C128.6 20.8682 130.426 20.8682 131.554 21.9966C132.683 23.125 132.683 24.9509 131.554 26.0792L114.556 43.0784C113.993 43.641 113.252 43.9242 112.514 43.9242C111.776 43.9242 111.036 43.641 110.473 43.0784C109.345 41.95 109.345 40.1242 110.473 38.9958L127.472 21.9966ZM130.09 23.4606C129.77 23.1407 129.256 23.1407 128.936 23.4606L111.937 40.4597C111.617 40.7796 111.617 41.2946 111.937 41.6145C112.097 41.7741 112.304 41.8539 112.514 41.8539C112.724 41.8539 112.932 41.7741 113.092 41.6145L130.09 24.6153C130.41 24.2954 130.41 23.7804 130.09 23.4606ZM136.684 48.2973C138.194 47.6448 139.877 48.4135 140.469 49.9142C141.052 51.3906 140.402 53.1265 138.922 53.7715L123.978 60.2546C123.613 60.4125 123.234 60.4871 122.859 60.4871C121.702 60.4871 120.638 59.7719 120.191 58.6378C119.61 57.1611 120.258 55.4236 121.741 54.7803L136.684 48.2973ZM137.505 50.1979L122.565 56.6797C122.165 56.8528 121.92 57.3787 122.118 57.879C122.257 58.2343 122.566 58.4167 122.859 58.4167C122.957 58.4167 123.055 58.3981 123.155 58.3548L138.094 51.8735C138.496 51.6983 138.739 51.1709 138.543 50.6742C138.357 50.2017 137.884 50.0341 137.505 50.1979ZM14.6035 49.9142C15.1958 48.4134 16.874 47.6455 18.3873 48.2968L33.332 54.7803C34.815 55.4236 35.4631 57.161 34.8815 58.6377C34.4347 59.7719 33.3705 60.4871 32.2134 60.4871C31.839 60.4871 31.4608 60.4129 31.0956 60.255L16.1527 53.7722C14.6698 53.129 14.0219 51.3909 14.6035 49.9142ZM16.5296 50.6735C16.3325 51.1738 16.5775 51.6997 16.9766 51.8728L31.9178 58.3548C32.0176 58.3981 32.1155 58.4167 32.2134 58.4167C32.5065 58.4167 32.8152 58.2344 32.9552 57.879M16.5296 50.6735C16.716 50.202 17.1847 50.0338 17.5679 50.1981ZM2.63101 77.2072C3.05735 76.5686 3.7592 76.0148 4.67325 76.0148H26.349C27.2631 76.0148 27.9649 76.5686 28.3912 77.2072C28.822 77.8525 29.0541 78.6842 29.0541 79.5515C29.0541 80.4188 28.822 81.2505 28.3912 81.8958C27.9649 82.5344 27.2631 83.0882 26.349 83.0882H4.67325C3.7592 83.0882 3.05735 82.5344 2.63101 81.8958C2.20027 81.2505 1.96813 80.4188 1.96813 79.5515C1.96813 78.6842 2.20027 77.8525 2.63101 77.2072ZM4.35294 78.3567C4.17958 78.6164 4.03849 79.0354 4.03849 79.5515C4.03849 80.0676 4.17958 80.4866 4.35294 80.7463C4.53071 81.0126 4.67325 81.0179 4.67325 81.0179H26.349C26.349 81.0179 26.4916 81.0126 26.6693 80.7463C26.8427 80.4866 26.9838 80.0676 26.9838 79.5515C26.9838 79.0354 26.8427 78.6164 26.6693 78.3567C26.4916 78.0904 26.349 78.0851 26.349 78.0851H4.67325C4.67325 78.0851 4.53071 78.0904 4.35294 78.3567ZM122.043 79.5515C122.043 77.8225 123.2 76.0148 125.082 76.0148H151.093C152.976 76.0148 154.132 77.8225 154.132 79.5515C154.132 81.2805 152.976 83.0882 151.093 83.0882H125.082C123.2 83.0882 122.043 81.2805 122.043 79.5515ZM125.082 78.0851C124.748 78.0851 124.114 78.5138 124.114 79.5515C124.114 80.5892 124.748 81.0179 125.082 81.0179H151.093C151.427 81.0179 152.062 80.5892 152.062 79.5515C152.062 78.5138 151.427 78.0851 151.093 78.0851H125.082ZM120.191 95.4613C120.784 93.9587 122.467 93.1952 123.975 93.8436L138.92 100.328C140.403 100.971 141.051 102.709 140.469 104.185C140.023 105.32 138.959 106.035 137.801 106.035C137.427 106.035 137.049 105.961 136.684 105.803L121.741 99.3195C120.258 98.6761 119.61 96.9379 120.191 95.4613ZM122.117 96.2212C121.921 96.7215 122.166 97.2471 122.565 97.4201L137.506 103.903M122.117 96.2212C122.303 95.7507 122.775 95.5816 123.156 95.7453ZM31.915 95.7459L16.9783 102.226C16.5763 102.402 16.3333 102.929 16.5294 103.426C16.6694 103.782 16.9783 103.965 17.2714 103.965C17.3692 103.965 17.4671 103.946 17.567 103.903L32.5081 97.4201C32.9071 97.247 33.1522 96.721 32.9551 96.2206C32.7692 95.7504 32.2987 95.5812 31.915 95.7459ZM31.0984 93.8433C32.6077 93.1956 34.2883 93.9586 34.8812 95.4613C35.4628 96.938 34.815 98.6762 33.3321 99.3195L18.3901 105.802C18.025 105.96 17.6458 106.035 17.2714 106.035C16.1142 106.035 15.05 105.32 14.6033 104.185C14.0211 102.709 14.6712 100.974 16.1511 100.329L31.0984 93.8433ZM40.5178 111.02C41.6448 109.896 43.4699 109.892 44.5995 111.021C45.7278 112.15 45.7278 113.976 44.5995 115.104L27.6007 132.104C27.0381 132.666 26.2975 132.95 25.5594 132.95C24.8213 132.95 24.0807 132.666 23.5181 132.104C22.3898 130.975 22.3898 129.149 23.5181 128.021L40.5178 111.02ZM41.9799 112.486L24.9821 129.485C24.6622 129.805 24.6622 130.32 24.9821 130.64C25.1417 130.799 25.3493 130.879 25.5594 130.879C25.7695 130.879 25.9771 130.799 26.1367 130.64L43.1355 113.64C43.4554 113.32 43.4554 112.805 43.1355 112.485C42.8171 112.167 42.3012 112.166 41.9799 112.486ZM110.473 111.022C111.601 109.894 113.427 109.894 114.556 111.022L131.554 128.021C132.682 129.149 132.684 130.976 131.554 132.104M131.554 132.104C130.992 132.666 130.251 132.95 129.513 132.95C128.775 132.95 128.034 132.666 127.472 132.104L110.473 115.105C109.345 113.976 109.345 112.15 110.473 111.022M113.092 112.486C112.772 112.166 112.257 112.166 111.937 112.486C111.617 112.806 111.617 113.321 111.937 113.641L128.936 130.64C129.095 130.799 129.303 130.879 129.513 130.879C129.723 130.879 129.931 130.799 130.09 130.64C130.408 130.322 130.411 129.805 130.09 129.485L113.092 112.486ZM98.7707 122.289L105.253 137.232C105.906 138.741 105.137 140.426 103.637 141.018C103.268 141.164 102.888 141.231 102.516 141.231C101.381 141.231 100.264 140.591 99.7784 139.469L93.2966 124.526C92.6434 123.017 93.4121 121.332 94.9127 120.74C96.39 120.163 98.1268 120.804 98.7707 122.289ZM95.6714 122.666C95.2 122.853 95.0332 123.326 95.1962 123.703L101.678 138.645C101.807 138.943 102.13 139.161 102.516 139.161C102.638 139.161 102.759 139.139 102.877 139.092C103.349 138.906 103.516 138.432 103.353 138.055L96.8713 123.113C96.6991 122.716 96.1781 122.469 95.6714 122.666ZM74.4305 127.5C74.4305 125.802 75.9621 124.668 77.536 124.668C79.11 124.668 80.6416 125.802 80.6416 127.5V150.821C80.6416 152.519 79.11 153.653 77.536 153.653C75.9621 153.653 74.4305 152.519 74.4305 150.821V127.5ZM77.536 126.738C76.8202 126.738 76.5008 127.211 76.5008 127.5V150.821C76.5008 151.11 76.8202 151.583 77.536 151.583C78.2519 151.583 78.5712 151.11 78.5712 150.821V127.5C78.5712 127.211 78.2519 126.738 77.536 126.738Z" fill="${this.color}"/>
      <path d="M79.6343 3.27862V26.5998C79.6343 27.5934 78.7088 28.3965 77.5639 28.3965C76.419 28.3965 75.4936 27.5934 75.4936 26.5998V3.27862C75.4936 2.28504 76.419 1.48192 77.5639 1.48192C78.7088 1.48192 79.6343 2.28504 79.6343 3.27862Z" fill="${this.color}"/>
      <path d="M75.4936 127.5C75.4936 126.506 76.419 125.703 77.5639 125.703C78.7088 125.703 79.6343 126.506 79.6343 127.5V150.821C79.6343 151.815 78.7088 152.618 77.5639 152.618C76.419 152.618 75.4936 151.815 75.4936 150.821V127.5Z" fill="${this.color}"/>
      <path d="M26.8962 22.7286L43.895 39.7277C44.6191 40.4518 44.6191 41.6223 43.895 42.3464C43.5339 42.7075 43.0598 42.889 42.5857 42.889C42.1116 42.889 41.6375 42.7075 41.2764 42.3464L24.2776 25.3472C23.5535 24.6231 23.5535 23.4527 24.2776 22.7286C25.0017 22.0044 26.1721 22.0044 26.8962 22.7286Z" fill="${this.color}"/>
      <path d="M113.851 111.753L130.85 128.753C131.574 129.477 131.574 130.648 130.85 131.372C130.489 131.733 130.015 131.914 129.541 131.914C129.066 131.914 128.592 131.733 128.231 131.372L111.232 114.372C110.508 113.648 110.508 112.477 111.232 111.753C111.957 111.029 113.127 111.031 113.851 111.753Z" fill="${this.color}"/>
      <path d="M4.00673 77.0499H30.0176C31.1258 77.0499 32.0216 78.1681 32.0216 79.5515C32.0216 80.9348 31.1258 82.053 30.0176 82.053H4.00673C2.89856 82.053 2.00281 80.9348 2.00281 79.5515C2.00281 78.1681 2.89856 77.0499 4.00673 77.0499Z" fill="${this.color}"/>
      <path d="M150.427 82.053H128.751C127.827 82.053 127.081 80.9348 127.081 79.5515C127.081 78.1681 127.827 77.0499 128.751 77.0499H150.427C151.35 77.0499 152.097 78.1681 152.097 79.5515C152.097 80.9348 151.35 82.053 150.427 82.053Z" fill="${this.color}"/>
      <path d="M24.2776 128.753L41.2764 111.754C42.0005 111.03 43.1709 111.03 43.895 111.754C44.6191 112.478 44.6191 113.648 43.895 114.373L26.8962 131.372C26.5351 131.733 26.061 131.914 25.5869 131.914C25.1128 131.914 24.6387 131.733 24.2776 131.372C23.5535 130.649 23.5535 129.477 24.2776 128.753Z" fill="${this.color}"/>
      <path d="M112.542 42.889C112.068 42.889 111.594 42.7075 111.232 42.3464C110.508 41.6223 110.508 40.4518 111.232 39.7277L128.231 22.7286C128.955 22.0044 130.126 22.0044 130.85 22.7286C131.574 23.4527 131.574 24.6231 130.85 25.3472L113.851 42.3464C113.49 42.7075 113.016 42.889 112.542 42.889Z" fill="${this.color}"/>
      <path d="M15.5937 50.2941C15.983 49.3075 17.0606 48.8394 18.0053 49.2476L32.9474 55.73C33.8884 56.1381 34.3349 57.2698 33.9456 58.2583C33.6522 59.0031 32.9658 59.4519 32.2407 59.4519C32.0045 59.4519 31.7664 59.4055 31.534 59.3049L16.5919 52.8225C15.6509 52.4124 15.2044 51.2807 15.5937 50.2941Z" fill="${this.color}"/>
      <path d="M139.533 103.806C139.24 104.551 138.554 105 137.829 105C137.592 105 137.354 104.953 137.122 104.853L122.18 98.3698C121.239 97.9615 120.792 96.8298 121.182 95.8412C121.571 94.8545 122.647 94.3883 123.593 94.7946L138.535 101.277C139.476 101.688 139.923 102.819 139.533 103.806Z" fill="${this.color}"/>
      <path d="M50.7969 137.644L57.279 122.701C57.6871 121.76 58.8149 121.315 59.8072 121.702C60.7937 122.092 61.2619 123.171 60.8537 124.114L54.3716 139.057C54.064 139.768 53.3444 140.196 52.5842 140.196C52.3366 140.196 52.0871 140.151 51.8434 140.055C50.8568 139.666 50.3887 138.587 50.7969 137.644Z" fill="${this.color}"/>
      <path d="M103.284 14.0439C104.271 14.4333 104.739 15.5127 104.33 16.4557L97.8484 31.3987C97.5408 32.1091 96.8212 32.5372 96.061 32.5372C95.8134 32.5372 95.5639 32.4929 95.3202 32.397C94.3336 32.0076 93.8655 30.9281 94.2737 29.9852L100.756 15.0422C101.166 14.1011 102.292 13.6564 103.284 14.0439Z" fill="${this.color}"/>
      <path d="M59.8072 32.397C59.5635 32.4929 59.3139 32.5372 59.0663 32.5372C58.3061 32.5372 57.5865 32.1091 57.279 31.3987L50.7969 16.4557C50.3887 15.5127 50.8568 14.4333 51.8434 14.0439C52.8357 13.6564 53.9615 14.1011 54.3716 15.0422L60.8537 29.9852C61.2619 30.9281 60.7937 32.0076 59.8072 32.397Z" fill="${this.color}"/>
      <path d="M15.5937 103.806C15.2044 102.817 15.6509 101.686 16.5919 101.277L31.534 94.7946C32.4787 94.3883 33.5562 94.8545 33.9456 95.8412C34.3349 96.8298 33.8884 97.9615 32.9474 98.3698L18.0053 104.853C17.7728 104.953 17.5348 105 17.2986 105C16.5735 105 15.8871 104.551 15.5937 103.806Z" fill="${this.color}"/>
      <path d="M139.533 50.2941C139.923 51.2826 139.476 52.4143 138.535 52.8225L123.593 59.3049C123.361 59.4055 123.123 59.4519 122.887 59.4519C122.161 59.4519 121.475 59.0031 121.182 58.2583C120.792 57.2698 121.239 56.1381 122.18 55.73L137.122 49.2476C138.07 48.8394 139.144 49.3075 139.533 50.2941Z" fill="${this.color}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M80.6694 3.27868C80.6694 1.58048 79.1379 0.446801 77.5639 0.446801C75.9899 0.446801 74.4584 1.58048 74.4584 3.27868V26.5999C74.4584 28.2981 75.9899 29.4318 77.5639 29.4318C79.1379 29.4318 80.6694 28.2981 80.6694 26.5999V3.27868ZM77.5639 2.51716C78.2798 2.51716 78.5991 2.98974 78.5991 3.27868V26.5999C78.5991 26.8888 78.2798 27.3614 77.5639 27.3614C76.8481 27.3614 76.5287 26.8889 76.5287 26.5999V3.27868C76.5287 2.98973 76.8481 2.51716 77.5639 2.51716ZM103.661 13.0797C102.182 12.5023 100.452 13.147 99.8068 14.6287L93.324 29.5733C92.6709 31.0822 93.4395 32.7677 94.9401 33.3599C95.309 33.5051 95.6884 33.5724 96.061 33.5724C97.1958 33.5724 98.3118 32.9331 98.7981 31.8107L105.28 16.8677C105.933 15.3588 105.161 13.6719 103.661 13.0797ZM102.906 15.0076C103.377 15.1946 103.543 15.6681 103.381 16.0445L96.8987 30.9868C96.7697 31.2848 96.4464 31.5021 96.061 31.5021C95.9385 31.5021 95.818 31.4805 95.6994 31.4338C95.2275 31.2471 95.0606 30.7732 95.2237 30.3965L101.705 15.4558C101.88 15.0565 102.401 14.8113 102.906 15.0076ZM55.3206 14.6287C54.6749 13.147 52.9454 12.5023 51.4668 13.0797C49.9662 13.6719 49.1937 15.358 49.8469 16.8669L56.329 31.81C56.8151 32.9328 57.9313 33.5724 59.0664 33.5724C59.439 33.5724 59.8176 33.5054 60.1864 33.3602C61.6871 32.768 62.4569 31.0829 61.8037 29.574L55.3206 14.6287ZM53.4226 15.4558L59.9037 30.3965C60.0668 30.7732 59.8998 31.2471 59.428 31.4338C59.3094 31.4805 59.1889 31.5021 59.0664 31.5021C58.6809 31.5021 58.358 31.2855 58.229 30.9875L51.7469 16.0445C51.5839 15.6681 51.7504 15.1947 52.2214 15.0077C52.727 14.8111 53.2483 15.0557 53.4226 15.4558ZM128.963 23.4606C129.283 23.1408 129.798 23.1408 130.118 23.4606C130.438 23.7805 130.438 24.2955 130.118 24.6153L113.119 41.6145C112.959 41.7741 112.752 41.8539 112.542 41.8539C112.332 41.8539 112.124 41.7741 111.964 41.6145C111.645 41.2946 111.645 40.7796 111.964 40.4598L128.963 23.4606ZM27.6282 21.9966C26.4999 20.8683 24.674 20.8683 23.5456 21.9966C22.4173 23.125 22.4173 24.9509 23.5456 26.0793L40.5444 43.0784C41.107 43.641 41.8476 43.9243 42.5857 43.9243C43.3238 43.9243 44.0644 43.641 44.627 43.0784C45.7554 41.9501 45.7554 40.1242 44.627 38.9958L27.6282 21.9966ZM25.0096 23.4606C25.3294 23.1408 25.8444 23.1408 26.1642 23.4606L43.163 40.4598C43.4829 40.7796 43.4829 41.2946 43.163 41.6145C43.0034 41.7741 42.7958 41.8539 42.5857 41.8539C42.3756 41.8539 42.1681 41.7742 42.0084 41.6145L25.0096 24.6153C24.6898 24.2955 24.6898 23.7805 25.0096 23.4606ZM18.4159 48.2974C16.9055 47.6448 15.223 48.4135 14.6308 49.9142C14.0482 51.3906 14.6983 53.1265 16.1784 53.7715L31.122 60.2546C31.4871 60.4126 31.8663 60.4871 32.2407 60.4871C33.3978 60.4871 34.462 59.7719 34.9087 58.6378C35.4903 57.1611 34.8423 55.4236 33.3593 54.7803L18.4159 48.2974ZM17.5947 50.1979L32.5354 56.6797C32.9345 56.8528 33.1795 57.3787 32.9824 57.879C32.8425 58.2344 32.5338 58.4168 32.2407 58.4168C32.1427 58.4168 32.0449 58.3981 31.945 58.3549L17.0055 51.8736C16.6035 51.6984 16.3606 51.1709 16.5566 50.6742C16.7431 50.2017 17.2157 50.0341 17.5947 50.1979ZM140.496 49.9142C139.904 48.4134 138.226 47.6455 136.713 48.2968L121.768 54.7803C120.285 55.4236 119.637 57.161 120.218 58.6377C120.665 59.7719 121.729 60.4871 122.887 60.4871C123.261 60.4871 123.639 60.413 124.004 60.255L138.947 53.7722C140.43 53.129 141.078 51.3909 140.496 49.9142ZM138.57 50.6735C138.767 51.1739 138.522 51.6997 138.123 51.8728L123.182 58.3549C123.082 58.3981 122.984 58.4168 122.887 58.4168C122.593 58.4168 122.285 58.2344 122.145 57.879M138.57 50.6735C138.384 50.202 137.915 50.0338 137.532 50.1981ZM152.469 77.2072C152.043 76.5686 151.341 76.0148 150.427 76.0148H128.751C127.837 76.0148 127.135 76.5686 126.709 77.2072C126.278 77.8525 126.046 78.6843 126.046 79.5515C126.046 80.4188 126.278 81.2506 126.709 81.8958C127.135 82.5345 127.837 83.0882 128.751 83.0882H150.427C151.341 83.0882 152.043 82.5345 152.469 81.8958C152.9 81.2506 153.132 80.4188 153.132 79.5515C153.132 78.6843 152.9 77.8525 152.469 77.2072ZM150.747 78.3567C150.92 78.6164 151.061 79.0354 151.061 79.5515C151.061 80.0676 150.92 80.4866 150.747 80.7463C150.569 81.0126 150.427 81.0179 150.427 81.0179H128.751C128.751 81.0179 128.608 81.0126 128.431 80.7463C128.257 80.4866 128.116 80.0676 128.116 79.5515C128.116 79.0354 128.257 78.6164 128.431 78.3567C128.608 78.0904 128.751 78.0851 128.751 78.0851H150.427C150.427 78.0851 150.569 78.0904 150.747 78.3567ZM33.0568 79.5515C33.0568 77.8225 31.9 76.0148 30.0177 76.0148H4.00675C2.12437 76.0148 0.967651 77.8225 0.967651 79.5515C0.967651 81.2805 2.12437 83.0882 4.00675 83.0882H30.0177C31.9 83.0882 33.0568 81.2805 33.0568 79.5515ZM30.0177 78.0851C30.3516 78.0851 30.9864 78.5138 30.9864 79.5515C30.9864 80.5893 30.3516 81.0179 30.0177 81.0179H4.00675C3.67279 81.0179 3.038 80.5893 3.038 79.5515C3.038 78.5138 3.67279 78.0851 4.00675 78.0851H30.0177ZM34.9085 95.4613C34.3156 93.9587 32.6328 93.1952 31.125 93.8437L16.18 100.328C14.697 100.971 14.049 102.709 14.6305 104.185C15.0773 105.32 16.1414 106.035 17.2986 106.035C17.6731 106.035 18.0513 105.961 18.4164 105.803L33.3593 99.3195C34.8423 98.6762 35.4901 96.938 34.9085 95.4613ZM32.9827 96.2212C33.1793 96.7215 32.9343 97.2471 32.5354 97.4201L17.5942 103.903M32.9827 96.2212C32.797 95.7507 32.3251 95.5817 31.9435 95.7454ZM123.185 95.7459L138.122 102.226C138.524 102.402 138.767 102.929 138.571 103.426C138.431 103.782 138.122 103.965 137.829 103.965C137.731 103.965 137.633 103.946 137.533 103.903L122.592 97.4202C122.193 97.2471 121.948 96.7211 122.145 96.2206C122.331 95.7504 122.801 95.5812 123.185 95.7459ZM124.002 93.8434C122.492 93.1956 120.812 93.9587 120.219 95.4613C119.637 96.938 120.285 98.6762 121.768 99.3195L136.71 105.802C137.075 105.96 137.454 106.035 137.829 106.035C138.986 106.035 140.05 105.32 140.497 104.185C141.079 102.709 140.429 100.974 138.949 100.329L124.002 93.8434ZM114.582 111.02C113.455 109.896 111.63 109.892 110.5 111.021C109.372 112.15 109.372 113.976 110.5 115.104L127.499 132.104C128.062 132.666 128.802 132.95 129.541 132.95C130.279 132.95 131.019 132.666 131.582 132.104C132.71 130.975 132.71 129.149 131.582 128.021L114.582 111.02ZM113.12 112.486L130.118 129.485C130.438 129.805 130.438 130.32 130.118 130.64C129.958 130.799 129.751 130.879 129.541 130.879C129.33 130.879 129.123 130.799 128.963 130.64L111.964 113.64C111.645 113.32 111.645 112.805 111.964 112.485C112.283 112.167 112.799 112.166 113.12 112.486ZM44.627 111.022C43.4987 109.894 41.6728 109.894 40.5444 111.022L23.5456 128.021C22.4181 129.149 22.4165 130.976 23.5456 132.104M23.5456 132.104C24.1081 132.666 24.8493 132.95 25.5869 132.95C26.325 132.95 27.0656 132.666 27.6282 132.104L44.627 115.105C45.7554 113.976 45.7554 112.15 44.627 111.022M42.0084 112.486C42.3282 112.166 42.8432 112.166 43.163 112.486C43.4829 112.806 43.4829 113.321 43.163 113.641L26.1642 130.64C26.0046 130.799 25.797 130.879 25.5869 130.879C25.3768 130.879 25.1693 130.799 25.0096 130.64C24.6915 130.323 24.6892 129.805 25.0096 129.485L42.0084 112.486ZM56.3293 122.289L49.8472 137.232C49.1941 138.741 49.9627 140.426 51.4633 141.018C51.8322 141.164 52.2116 141.231 52.5842 141.231C53.7192 141.231 54.8355 140.591 55.3216 139.469L61.8034 124.526C62.4565 123.017 61.6879 121.332 60.1873 120.74C58.71 120.163 56.9731 120.804 56.3293 122.289ZM59.4286 122.666C59.9 122.853 60.0667 123.326 59.9037 123.703L53.4219 138.645C53.2929 138.943 52.9697 139.161 52.5842 139.161C52.4617 139.161 52.3412 139.139 52.2226 139.092C51.7508 138.906 51.5838 138.432 51.7469 138.055L58.2286 123.113C58.4009 122.716 58.9219 122.469 59.4286 122.666ZM80.6694 127.5C80.6694 125.802 79.1379 124.668 77.5639 124.668C75.99 124.668 74.4584 125.802 74.4584 127.5V150.821C74.4584 152.519 75.99 153.653 77.5639 153.653C79.1379 153.653 80.6694 152.519 80.6694 150.821V127.5ZM77.5639 126.738C78.2798 126.738 78.5991 127.211 78.5991 127.5V150.821C78.5991 151.11 78.2798 151.583 77.5639 151.583C76.8481 151.583 76.5287 151.11 76.5287 150.821V127.5C76.5287 127.211 76.8481 126.738 77.5639 126.738Z" fill="${this.color}"/>
      <path d="M53.0346 98.3643V102.066C53.0346 102.785 53.8748 103.367 54.9143 103.367H101.186C102.226 103.367 103.066 102.785 103.066 102.066V98.3643H53.0346Z" fill="${this.color}"/>
      <path d="M106.836 65.9049C106.836 66.2068 106.9 66.5005 106.947 66.7963L97.1893 73.2328L82.7113 54.8408C83.9575 53.6054 84.704 51.9072 84.704 50.0602C84.704 46.348 81.718 43.3299 78.0452 43.3299C74.3725 43.3299 71.3865 46.348 71.3865 50.0602C71.3865 51.9092 72.137 53.6094 73.3792 54.8428L58.9031 73.2328L49.145 66.7963C49.1927 66.5005 49.2584 66.2047 49.2584 65.9049C49.2584 62.7762 46.7363 60.233 43.6368 60.233C40.5414 60.233 38.0252 62.7782 38.0252 65.9049C38.0252 68.9572 40.418 71.438 43.4039 71.5648L50.7614 93.3612H105.339L112.696 71.5648C115.68 71.438 118.075 68.9572 118.075 65.9049C118.075 62.7762 115.557 60.233 112.464 60.233C109.358 60.233 106.836 62.7782 106.836 65.9049Z" fill="${this.color}"/>
      </svg>
      `;
    },

  },
  methods: {
    ...mapActions("bannerCarousel", ["init"]),
    lines(needToBuy) {
      const gap = 10;
      const circleRadius = this.mobile ? 35 : 55;
      const dashLength = 2 * circleRadius * 3.1415 * (1 / needToBuy) - gap;
      return {
        strokeDasharray: `${dashLength}px ${gap}px`,
        strokeDashoffset: `-${gap / 2}px`,
      };
    },
    openItem(product) {
      const isMobile = !!this.$vuetify.breakpoint.xsOnly;
      this.$store.dispatch("product/setCurrentProductDetails", product, { root: true });
      if (isMobile) this.$router.push(`product/${product.upc_encoded}`);
      else {
        const view = getProductDetailViewFromProductState(product);
        this.$store.dispatch("product/openDialog", view);
      }
    },
    openRewards() {
      const isMobile = !!this.$vuetify.breakpoint.xsOnly;
      if (isMobile) this.$router.push("rewards");
      else this.$router
        .push("account#rewards")
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

.banner-carousel {
  position: relative;
  height: 196px;
  width: 814px;
}

.banner-carousel.mobile {
  height: 112.5px;
  width: 360px;
}

.dots {
  width: 56px;
  height: 8px;
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: -63px;
  left: calc((100% - 56px) / 2);

  & .circle {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #9e9e9e;

    &.active {
      background-color: v-bind(color);
    }
  }
}

.dots.mobile {
  width: 32px;
  height: 5px;
  bottom: -16px;
  left: calc((100% - 32px) / 2);

  & .circle {
    height: 5px;
    width: 5px;
  }
}

.custom-banner {
  height: 196px;
  background-size: contain;
  background-repeat: no-repeat;
}

.custom-banner.mobile {
  height: 112.5px;
  background-position: center;
}

.banner {
  display: flex;
  align-items: flex-end;
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  font-family: Roboto, serif;
  color: #000;
  overflow: clip;
  width: 814px;
  height: 196px;

  & .image {
    height: 172px;
    min-width: 180px;
    max-width: 180px;
    background-size: contain;
    margin: 12px;
    margin-right: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid #d6d6d6;

    &.department {
      background-size: cover;
    }
  }

  & svg.circle {
    width: 120px;
    height: 120px;
  }

  & svg.circle image {
    height: 80px;
    width: 80px;
    transform: translate(20px, 20px);
  }

  & svg.circle circle {
    r: 55px;
    cx: 60px;
    cy: 60px;
    fill: none;
    stroke-width: 10px;
    stroke: #cdcbcb;
  }

  & .background {
    display: flex;
    align-items: flex-end;
    background-color: white;
    width: 85%;
    border-top-right-radius: 10rem;
    border-bottom-right-radius: 10rem;
  }

  & .main {
    & .name {
      font-size: 32px;
      font-weight: bold;
      display: flex;
      line-height: 1;
      min-height: 90px;
      max-height: 90px;
      overflow: hidden;
      align-items: center;

      &.promotion {
        max-width: 550px;
      }

      &.department {
        font-size: 48px;
        min-height: 110px;
        max-height: 110px;
      }

      &.with-crown {
        max-width: 240px;
      }
    }

    & .modifier {
      font-size: 16px;
    }

    & .price {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 12px;
    }

    & .size {
      font-size: 16px;
      opacity: 0.6;
    }

    & .main-text {
      font-size: 22px;
      font-weight: 600;
      color: v-bind(color);
      margin-bottom: 9px;
    }

    & .subs {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
      width: 440px;
      margin-bottom: 9px;
    }

    & .sub {
      font-weight: bold;
      display: inline;
    }

    & .sub:not(:last-child)::after {
      content: '•';
      margin: 5px;
      line-height: 0;
      vertical-align: middle;
    }
  }

  & .crown {
    margin-left: auto;
    padding: 0 28px 14px 0;
  }

  & .ribbon {
    position: absolute;
    top: 18px;
    right: -35px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: #e21b23;
    width: 130px;
    text-align: center;
    color: white;
    font-size: 16px;
  }

  & .ribbon.large {
    top: 30px;
    right: -48px;
    width: 200px;
    font-size: 28px;
  }

  & .information {
    background-color: #f9d1d3;
    font-size: 13px;
    color: #e21b23;
    border-radius: 8px;
    font-weight: bold;
    position: absolute;
    right: 12px;
    bottom: 12px;
    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }
}

.banner.mobile {
  width: 360px;
  height: 112.5px;

  & .image {
    height: 96px;
    min-width: 96px;
    max-width: 96px;
    margin: 8px;
  }

  & svg.circle {
    width: 96px;
    height: 96px;
  }

  & svg.circle image {
    height: 50px;
    width: 50px;
    transform: translate(23px, 23px);
  }

  & svg.circle circle {
    r: 35px;
    cx: 48px;
    cy: 48px;
    stroke-width: 6px;
  }

  & .main {
    & .name {
      font-size: 16px;
      min-height: 50px;
      max-height: 50px;
      max-width: 185px;

      &.department, &.with-crown, &.promotion {
        font-size: 24px;
        max-width: 190px;
      }
    }

    & .subs {
      width: 180px;
    }

    & .main-text {
      font-size: 16px;
    }

    & .modifier, .price, .size {
      font-size: 10px;
      font-weight: 600;
      opacity: 1;
    }
  }

  & .crown {
    padding: 11px;
  }

  & .ribbon {
    font-weight: 600;
  }

  & .information {
    height: 29px;
    right: 40px;
    bottom: 15px;
    padding: 4px;
  }
}
</style>
